import { type ComponentType, memo, type PropsWithChildren } from 'react';
import type { SlideFadeProps } from '@chakra-ui/react';
import { SlideFade as ChakraSlideFade } from '@chakra-ui/react';

export const SlideFade = memo(ChakraSlideFade as ComponentType<PropsWithChildren<SlideFadeProps>>);
